import classNames from 'classnames';
import React, { useEffect, useMemo, useState } from 'react';
import { Nav } from 'react-bootstrap';

const FilterTab = ({ tabItems = [], className, activeKey, onSelect }) => {
  const firstValue = useMemo(() => tabItems?.[0]?.value ?? 'all', [tabItems]);

  // controlled if activeKey is provided, otherwise uncontrolled
  const isControlled = activeKey != null;

  const [internalActive, setInternalActive] = useState(firstValue);

  // keep internal state in sync when tabs change (e.g., data loaded)
  useEffect(() => {
    if (!isControlled) setInternalActive(firstValue);
  }, [firstValue, isControlled]);

  const currentActive = isControlled ? activeKey : internalActive;

  const handleClick = item => {
    if (!item) return;

    if (!isControlled) setInternalActive(item.value);

    if (typeof onSelect === 'function') {
      onSelect(item.value);
    }

    // backward compatibility: if someone still uses item.onClick
    if (item.onClick) {
      item.onClick();
    }
  };

  if (!tabItems?.length) return null;

  return (
    <Nav className={classNames(className, 'nav nav-links mx-n2')}>
      {tabItems.map(item => (
        <Nav.Item key={item.value ?? item.label}>
          <Nav.Link
            onClick={() => handleClick(item)}
            className={classNames('px-2', {
              active: currentActive === item.value
            })}
          >
            {item.label}{' '}
            <span className="text-700 fw-semi-bold">({item.count})</span>
          </Nav.Link>
        </Nav.Item>
      ))}
    </Nav>
  );
};

export default FilterTab;
